import { useTranslation } from 'react-i18next';

function AIAgentsPage() {
    const { t } = useTranslation('ecosystem');

    return (
        <section className="page">
            <h1 className="page__title">{t('ai.title')}</h1>
            <p className="page__text">{t('ai.description')}</p>
        </section>
    );
}

export default AIAgentsPage;
